<template>
  <v-col cols="12" class="text-center my-6">
    <h1 class="text-h5 align-center mb-6 secondary--text">
      <!-- <v-icon left color="accent">mdi-tag-outline</v-icon> -->
      <span class="accent--text">Topic: </span>
      <span v-html="title"></span>
    </h1>
    <p class="grey--text text--darken-1 mb-6" xv-html="description" v-if="description">
      Accumsan dignissim suscipit accumsan eleifend curae cum ultrices posuere a vestibulum a magnis metus ullamcorper donec augue a curabitur
    </p>
    <!-- <v-divider></v-divider> -->
  </v-col>
<!--   <v-card flat class="transparent ch-card--header ch-post__meta">
    <v-card-title class="primary--text">
      <v-icon left color="primary">mdi-tag</v-icon>
      <span v-html="title"></span>
    </v-card-title>
    <v-card-text v-if="description" v-html="description"></v-card-text>
  </v-card> -->
</template>

<script>
  export default {
    name: 'TagHeader',

    // props: ['title', 'description']
    props: {
      title: {
        type: String,
        default: 'Tag'
      },
      description: {
        type: String,
        default: 'lorem ipsum dolor est amit'
      }
    }
  }
</script>

<!-- <style lang="sass" scoped>
  .ch-card--header .v-card__title > span
    margin-left: 6px
    text-transform: uppercase
</style> -->